import React, { useEffect } from 'react';
import { Box, Typography, FormControlLabel, RadioGroup, Radio } from '@material-ui/core';

const SubcategoriesRadio = ({ name, values, value, label, onHandleChange }) => {
    useEffect(() => {
        if (!value) {
            onHandleChange(name, values[0]?.id, 'radio2');
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const handleChange = e => {
        onHandleChange(name, e.target.value, 'radio2');
    };

    return (
        <Box>
            <Box mb={1}>
                <Typography variant="body2">{label}</Typography>
            </Box>
            <Box display="flex" flexDirection="column">
                <RadioGroup name={name} defaultValue={values[0]?.id} value={value} onChange={handleChange}>
                    {values.map((value, index) => (
                        <FormControlLabel key={index} value={value?.id} control={<Radio />} label={value?.name} />
                    ))}
                </RadioGroup>
            </Box>
        </Box>
    );
};

export default SubcategoriesRadio;
